module.exports = __webpack_public_path__ + "img/main-content-error.f5fc0301.svg";